import React, { useState, useEffect } from "react";
import { toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";
import { Link } from "react-router-dom";
import Select from "react-select";
import SortableTable from "../../components/SortableTable";
import { getApi } from "../../utils/api";
import Cookies from "js-cookie";
import { API_GET_EMAIL_DELETION_REQUESTS } from "../../config/Endpoints";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { ThreeDots } from "react-loader-spinner";

const EmailDeletion = ({ title, description }) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const accessToken = Cookies.get("accessToken");
  const [loading, setLoading] = useState(false);
  const requestStatusOptions = [
    { value: "approved", label: "Approved Requests" },
    { value: "pending", label: "Pending Requests" },
    { value: "rejected", label: "Rejected Requests" },
  ];

  useEffect(() => {
    const fetchRequests = async () => {
      setLoading(true);
      try {
        const response = await getApi(
          API_GET_EMAIL_DELETION_REQUESTS,
          accessToken
        );

        if (
          response?.data?.statusCode === 200 &&
          Array.isArray(response.data.data)
        ) {
          setRequests(response.data.data);
          setFilteredRequests(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching requests:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, []);

  const handleFilterChange = (value) => {
    setSelectedStatus(value);
    if (value !== null && value !== "all") {
      const statusMap = { approved: 1, pending: 0, rejected: 2 };
      setFilteredRequests(
        requests.filter((req) => req.reqStatus === statusMap[value])
      );
    } else {
      setFilteredRequests(requests);
    }
  };

  useEffect(() => {
    const filtered = requests.filter((req) =>
      req.fullName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (selectedStatus) {
      const statusMap = { approved: 1, pending: 0, rejected: 2 };
      setFilteredRequests(
        filtered.filter((req) => req.reqStatus === statusMap[selectedStatus])
      );
    } else {
      setFilteredRequests(filtered);
    }
  }, [searchTerm, selectedStatus, requests]);

  const columns = [
    { key: "employeeName", label: "Employee Name" },
    { key: "designation", label: "Designation" },
    { key: "reason", label: "Action Required" },
    { key: "status", label: "Status" },
  ];
  const tableData = filteredRequests.map((req) => ({
    employeeName: req.fullName,
    designation: req.designation,
    reason: req.reqReason,
    status:
      req.reqStatus === 1
        ? "Approved"
        : req.reqStatus === 2
        ? "Rejected"
        : "Pending",
    _original: req,
  }));

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>

      <div className="filters gap-3">
        {/* Search by Employee Name */}
        <div className="search">
          <input
            type="text"
            name="search"
            placeholder="Search By Employee Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <img src="/assets/images/search-ico.svg" width="14" alt="Search" />
        </div>

        {/* Filter by Status */}
        <div className="search">
          <Select
            className="custom-select  col-md-12 col-sm-12"
            classNamePrefix="react-select"
            options={requestStatusOptions}
            value={
              requestStatusOptions.find(
                (status) => status.value === selectedStatus
              ) || null
            }
            onChange={(selectedOption) =>
              handleFilterChange(selectedOption ? selectedOption.value : null)
            }
            placeholder="Filter by Status"
            isClearable
          />
        </div>

        {/* Action Button */}
        <Link className="btn theme-button" to="/dashboard/emailDeletionRequest">
          Add Email Deletion Request
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center mt-5">
          <div className="centered-loader">
            <ThreeDots
              height="100"
              width="100"
              radius="9"
              color="blue"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      ) : tableData.length === 0 ? (
        <NoRecordsAvailable />
      ) : (
        <SortableTable columns={columns} data={tableData} />
      )}
    </div>
  );
};

export default EmailDeletion;
